import { Account, TableType } from './types';

// ***
// AVOID ADDING NEW STRING_HEADERS
//
// String headers usually contain metadata and are hardcoded in the parsing
// logic. Try to find equivalent string header instead of adding new ones.
// ***
export const STRING_HEADERS = [
  '号室',
  '契約者',
  '備考',
  '番号',
  '受取者',
  '項目',
  '支付者',
] as const;

export const NUMERIC_HEADERS = [
  '賃料',
  '管理費',
  '毎月支払額',
  '預かり清掃費',
  '敷金',
  '更新料',
  '礼金',
  '入金額',
  '出金額',
  '支払額',
  '源泉徴収税',
  '源泉税',
  '消費税',
  '共益費',
  '駐車料',
  '看板使用料',
  'その他',
  '解約費・更新費',
  'その他支払',
  '控除',
] as const;

type StringHeader = typeof STRING_HEADERS[number];
type NumericHeader = typeof NUMERIC_HEADERS[number];

export function isNumericHeader(h: string): h is NumericHeader {
  return NUMERIC_HEADERS.includes(h as any);
}

export type ParseTableHeaderConfig = {
  kind: 'numeric';
  name: NumericHeader;
  // TODO: rename this to defaultAccount
  account: Account;
  // TODO: test includeInSum
  includeInSum?: boolean;
} | {
  // For cells that we don't want to gather amount from
  // (e.g. tenant name and notes)
  kind: 'metadata';
  name: StringHeader | NumericHeader | "EMPTY";
};

export type ParseTableConfig = {
  // Ends up in the description of each journal entry
  displayName: TableType;

  // If true, treat the whole table as a single journal id.
  // If false, each row has a journal id, with columns forming entries.
  singleJournalId?: boolean;

  // If set, automatically creates a debit or credit JournalEntry if entries
  // with the same JournalId are not balanced.
  // TODO: test
  autoBalanceAccount?: Account;

  // Sometimes, a debit table like "支出" uses negative numbers to express
  // expenses, leading to the software clssifying them as "credits".
  // Set this to true to reverse the sign.
  // TODO: test
  reverseSign?: boolean;

  // e.g. "A7:K24"
  // If number, means how many rows to skip.
  // If not provided, means the whole sheet.
  range?: string | number;

  // Note the order matters.
  headers: Array<ParseTableHeaderConfig>;
};

export type ParseSheetConfig = {
  // Defaults to "Input"
  sheetName?: string;

  tables: Array<ParseTableConfig>;
};
